import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, onClearFilters }) => {
  const helperTypeOptions = [
    { value: 'all', label: 'All Helpers' },
    { value: 'lived-experience', label: 'Lived-Experience Volunteers' },
    { value: 'licensed', label: 'Licensed Professionals' }
  ];

  const proximityOptions = [
    { value: 'any', label: 'Any Location' },
    { value: 'same-building', label: 'Same Building' },
    { value: 'same-site', label: 'Same Site' },
    { value: 'within-5km', label: 'Within 5km' }
  ];

  const availabilityOptions = [
    { value: 'any', label: 'Any Time' },
    { value: 'today', label: 'Available Today' },
    { value: 'this-week', label: 'This Week' },
    { value: 'next-week', label: 'Next Week' }
  ];

  const languageOptions = [
    { value: 'english', label: 'English' },
    { value: 'spanish', label: 'Spanish' },
    { value: 'mandarin', label: 'Mandarin' },
    { value: 'french', label: 'French' },
    { value: 'arabic', label: 'Arabic' },
    { value: 'hindi', label: 'Hindi' }
  ];

  const topicOptions = [
    { id: 'anxiety', label: 'Anxiety & Stress' },
    { id: 'depression', label: 'Depression' },
    { id: 'grief', label: 'Grief & Loss' },
    { id: 'workplace', label: 'Workplace Issues' },
    { id: 'relationships', label: 'Relationships' },
    { id: 'trauma', label: 'Trauma' },
    { id: 'addiction', label: 'Addiction Recovery' },
    { id: 'family', label: 'Family Concerns' }
  ];

  const handleTopicToggle = (topicId) => {
    const currentTopics = filters?.topics || [];
    const newTopics = currentTopics?.includes(topicId)
      ? currentTopics?.filter(id => id !== topicId)
      : [...currentTopics, topicId];
    onFilterChange('topics', newTopics);
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="SlidersHorizontal" size={20} className="text-primary" />
          Filter Helpers
        </h2>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onClearFilters}
        >
          Clear All
        </Button>
      </div>
      <div className="space-y-4">
        <Select
          label="Helper Type"
          options={helperTypeOptions}
          value={filters?.helperType}
          onChange={(value) => onFilterChange('helperType', value)}
        />

        <Select
          label="Availability"
          options={availabilityOptions}
          value={filters?.availability}
          onChange={(value) => onFilterChange('availability', value)}
        />

        <Select
          label="Location Proximity"
          options={proximityOptions}
          value={filters?.proximity}
          onChange={(value) => onFilterChange('proximity', value)}
        />

        <Select
          label="Language Preference"
          options={languageOptions}
          value={filters?.language}
          onChange={(value) => onFilterChange('language', value)}
          searchable
          clearable
        />

        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground">
            Topic Expertise
          </label>
          <div className="space-y-2">
            {topicOptions?.map((topic) => (
              <Checkbox
                key={topic?.id}
                label={topic?.label}
                checked={(filters?.topics || [])?.includes(topic?.id)}
                onChange={() => handleTopicToggle(topic?.id)}
              />
            ))}
          </div>
        </div>

        <div className="pt-4 border-t border-border">
          <Checkbox
            label="Show only verified professionals"
            checked={filters?.verifiedOnly}
            onChange={(e) => onFilterChange('verifiedOnly', e?.target?.checked)}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;